import React, { useState } from "react";
import { M } from "./tokens";
import { useBrand } from "./BrandContext";
import { requestAsset } from "../../lib/api";

/* Per-machine "get your own" CTA. Opens an inline email field, posts an
   asset request, then confirms in place. No modal, no page change. */
export default function LeadMagnet({ machineId, label, asset, accent }) {
  const { brand, brandUrl, revenue, cpa, aov, offerMode } = useBrand();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [err, setErr] = useState("");
  const [delivery, setDelivery] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErr("That email does not look right.");
      return;
    }
    setErr("");
    setState("sending");
    try {
      const result = await requestAsset({
        email,
        machine_id: machineId,
        requested_asset: asset,
        brand,
        brand_url: brandUrl,
        monthly_revenue: revenue,
        blended_cpa: cpa,
        average_order_value: aov,
        offer_mode: offerMode,
      });
      setDelivery(result?.delivery || "backend");
      setState("done");
    } catch {
      setState("error");
      setErr("Could not send that. Try again.");
    }
  };

  if (state === "done") {
    return (
      <div
        className="f-mono rounded-lg px-3.5 py-2.5 text-[10px] uppercase tracking-[0.12em]"
        style={{ border: `1px solid ${accent}55`, background: `${accent}12`, color: accent }}
        data-testid={`magnet-done-${machineId}`}
      >
        {delivery === "email" ? `Email request opened for ${email}. Send it to finish.` : `On its way. Check ${email}.`}
      </div>
    );
  }

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid={`magnet-open-${machineId}`}
        className="focus-ring f-mono rounded-lg px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.12em] transition-transform hover:-translate-y-[1px] active:translate-y-0"
        style={{ border: `1px solid ${accent}66`, background: `${accent}12`, color: accent }}
      >
        {label}
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-2" data-testid={`magnet-form-${machineId}`}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@brand.com"
        autoFocus
        data-testid={`magnet-email-${machineId}`}
        className="focus-ring f-mono rounded-lg px-3 py-2.5 text-[11px] outline-none"
        style={{ background: M.surface2, border: `1px solid ${M.border}`, color: M.ink, minWidth: 190 }}
      />
      <button
        type="submit"
        disabled={state === "sending"}
        data-testid={`magnet-send-${machineId}`}
        className="focus-ring f-mono rounded-lg px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.12em] disabled:opacity-60"
        style={{ background: accent, color: "#06110C" }}
      >
        {state === "sending" ? "Sending" : "Send it"}
      </button>
      {err && (
        <span className="f-mono text-[10px]" style={{ color: M.danger }} data-testid={`magnet-error-${machineId}`}>
          {err}
        </span>
      )}
    </form>
  );
}
